import * as React from "react";
const SvgFiRrBinoculars = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-binoculars_svg__a)">
      <path
        fill="#062147"
        d="M22.536 6.464A4.96 4.96 0 0 0 20 5.101V3c0-1.654-1.346-3-3-3s-3 1.346-3 3v2h-4V3c0-1.654-1.346-3-3-3S4 1.346 4 3v2.101a4.97 4.97 0 0 0-2.536 1.363A4.97 4.97 0 0 0 0 10v8.5C0 21.533 2.467 24 5.5 24c2.979 0 5.406-2.382 5.492-5.34 0-.014.008-.026.008-.04V13c0-.551.449-1 1-1s1 .449 1 1v5.62c0 .014.008.026.008.04.086 2.958 2.513 5.34 5.492 5.34 3.033 0 5.5-2.467 5.5-5.5V10c0-1.335-.52-2.591-1.464-3.536M16 3c0-.551.449-1 1-1s1 .449 1 1v2h-2zM7 2c.551 0 1 .449 1 1v2H6V3c0-.551.449-1 1-1M5.5 22C3.57 22 2 20.43 2 18.5S3.57 15 5.5 15 9 16.57 9 18.5 7.43 22 5.5 22M12 10c-1.654 0-3 1.346-3 3v1.261A5.48 5.48 0 0 0 5.5 13 5.48 5.48 0 0 0 2 14.261V10c0-.801.312-1.555.879-2.121A2.98 2.98 0 0 1 5 7.001h14.001c.801 0 1.554.312 2.121.878S22 9.199 22 10v4.261A5.48 5.48 0 0 0 18.5 13a5.48 5.48 0 0 0-3.5 1.261V13c0-1.654-1.346-3-3-3m6.5 12c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-binoculars_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBinoculars;
